import { Component, model, OnInit, signal } from '@angular/core';
import { IonToggle } from "@ionic/angular/standalone";
import { FormsModule } from "@angular/forms";
import { darkModeSignal } from "@shared/components/dark-mode-toggle/dark-mode.signal";

@Component({
  selector: 'pkp-dark-mode-toggle',
  templateUrl: './dark-mode-toggle.component.html',
  styleUrls: ['./dark-mode-toggle.component.scss'],
  standalone: true,
  imports: [IonToggle, FormsModule]
})
export class DarkModeToggleComponent implements OnInit {
  darkMode = darkModeSignal;
  readonly #storageKey = 'PKPDarkMode';

  ngOnInit() {
    const isDark = localStorage.getItem(this.#storageKey) === 'true';
    this.setDarkMode(isDark);
  }

  onToggle(event: CustomEvent) {
    this.setDarkMode(event.detail.checked);
  }

  private setDarkMode(isDark: boolean) {
    localStorage.setItem(this.#storageKey, String(isDark));
    this.darkMode.set(isDark);
    document.documentElement.classList.toggle('ion-palette-dark', isDark);
  }
}

